import { useNavigate, useSearchParams } from 'react-router-dom';
import EnergyOverview from './EnergyOverview';
import SustainabilityOverview from './SustainabilityOverview';
import CarbonEmissionOverview from './CarbonEmissionOverview';
import DataCenterScalingSimulator from './DataCenterScalingSimulator';
import { PieChart, Zap, Leaf, Activity, ArrowLeft } from 'lucide-react';

const tabs = [
    { id: 'simulator', label: 'Scaling Simulator', icon: Activity },
    { id: 'energy', label: 'Energy Overview', icon: Zap },
    { id: 'sustainability', label: 'Sustainability', icon: Leaf },
    { id: 'carbon', label: 'Carbon Emissions', icon: PieChart },
];

export default function DigitalTwinDashboardMain() {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'simulator';
    const clientId = searchParams.get('client');
    const navigate = useNavigate();

    const renderActiveDashboard = () => {
        switch (activeTab) {
            case 'energy':
                return <EnergyOverview />;
            case 'sustainability':
                return <SustainabilityOverview />;
            case 'carbon':
                return <CarbonEmissionOverview />;
            case 'simulator':
                return <DataCenterScalingSimulator />;
            default:
                return <DataCenterScalingSimulator />;
        }
    };

    const handleTabChange = (tabId: string) => {
        const params = new URLSearchParams(searchParams);
        params.set("tab", tabId);
        setSearchParams(params);
    };

    return (
        <div className="flex flex-col w-full h-full bg-[#0a0c10] overflow-hidden pb-10">


            {/* Header Tabs */}


            <div className="flex items-center gap-1 p-3 px-6 bg-[#11141b] border-b border-[#1f232c] shadow-sm z-10">
                <button onClick={() => navigate(`/digital-twin/model/${clientId}`)} className='px-2.5 py-2.5 rounded-lg text-xs text-white transition-all duration-300 relative group cursor-pointer'><ArrowLeft /></button>
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => handleTabChange(tab.id)}
                            className={`flex items-center gap-2.5 px-5 py-2.5 rounded-lg text-xs font-black transition-all duration-300 relative group
                                ${isActive
                                    ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20'
                                    : 'text-zinc-500 hover:text-zinc-200 hover:bg-white/5 border border-transparent'
                                }`}
                        >
                            <Icon size={14} className={isActive ? 'text-blue-400' : 'text-zinc-500 group-hover:text-zinc-300'} />
                            <span className="uppercase tracking-widest">{tab.label}</span>

                            {isActive && (
                                <div className="absolute bottom-[-13px] left-1/2 -translate-x-1/2 w-8 h-[2px] bg-blue-500 shadow-[0_0_8px_rgba(59,130,246,0.8)] rounded-full" />
                            )}
                        </button>
                    );
                })}
            </div>


            {/* Dashboard Content Container */}
            <div className="flex-1 overflow-y-auto custom-scroll p-6">
                <div className="max-w-[1600px] mx-auto w-full">
                    {renderActiveDashboard()}
                </div>
            </div>
        </div>
    );
}
